export default "__VITE_ASSET__DjV4F8Zb__"